import './Billing.css';

const PlanCard = ({ plan, billingCycle, currentPlan, onUpgrade, onContactSales, isLoading }) => {
    const isCurrent = currentPlan?.plan === plan.id && (currentPlan?.billingCycle === billingCycle || plan.id === 'free');

    return (
        <div className={`plan-card ${isCurrent ? 'current' : ''} ${plan.id}`}>
            {isCurrent && <div className="current-badge">Current Plan</div>}
            {billingCycle === 'annual' && plan.price > 0 && <div className="savings-ribbon">Save 17%</div>}

            <h3 className="plan-name">{plan.name}</h3>

            <div className="plan-price">
                {plan.price !== null ? (
                    <>
                        <span className="price-symbol">$</span>
                        <span className="price-amount">{billingCycle === 'annual' ? Math.floor(plan.annualPrice / 12) : plan.price}</span>
                        <span className="plan-period">/ month</span>
                        {billingCycle === 'annual' && plan.annualPrice && (
                            <div className="annual-billing-note">
                                , Billed annually (${plan.annualPrice}/yr)
                                <div className="savings-highlight">Save ${(plan.price * 12) - plan.annualPrice} per year</div>
                            </div>
                        )}
                    </>
                ) : (
                    "Custom"
                )}
            </div>

            <ul className="plan-features">
                {plan.features.map((feature, index) => (
                    <li key={index}>
                        <span className="check-icon">✓</span>
                        {feature}
                    </li>
                ))}
            </ul>

            {plan.contactUs ? (
                <button
                    className="plan-action btn-outline"
                    onClick={onContactSales}
                >
                    Contact Sales
                </button>
            ) : (
                !isCurrent && plan.id === 'free' ? null : (
                    <button
                        className={`plan-action ${isCurrent ? 'btn-disabled' : 'btn-primary'}`}
                        disabled={isCurrent || isLoading}
                        onClick={() => onUpgrade(plan)}
                    >
                        {isCurrent ? 'Current Plan' : isLoading ? 'Processing...' : `Select plan`}
                    </button>
                )
            )}
        </div>
    );
};

export default PlanCard;
